import request from '@/utils/request'

export function homeDataNumbers(data) {
  return request('v1/home/dataNumbers', {
    method: 'GET',
    params: {
      ...data
    }
  })
}

export function checkSystemUpgrade(data) {
  return request('/api/system-upgrade', {
    method: 'GET',
    params: {
      ...data
    }
  })
}
